const Messenger = (() => {
  const DEFAULT_MESSAGE_TEXT = 'NEW_CONVERSATION_INITIAL_BLANK_MESSAGE';
  // DATA
  let recipientUsersById;
  let unReadConversations;
  let conversationParticipantIdSets;
  // DOM
  let messagesContainer;

  function toggleUnreadMessageIndicator() {
    const unreadMessageIndicator = document.querySelector('.unreadMessageIndicator');

    if (unReadConversations.size > 0) {
      unreadMessageIndicator.classList.add('has-unread');
    } else {
      unreadMessageIndicator.classList.remove('has-unread');
    }
  }
  function setUnreadMessageCount(conversations) {
    unReadConversations = new Set();
    conversations?.getAllConversationsResult.forEach(convo => {
      if (convo.HasUnread) {
        unReadConversations.add(convo.ConversationId);
      }
    });
  }

  // New Message setup
  function showConversationAlreadyExistsWarning(callback) {
    const warningMessage = document.createElement('div');
    warningMessage.classList.add('conversationAlreadyExistsWarning');

    const message = document.createElement('p');
    message.textContent = 'Conversation with these participants already exists.';

    const okButton = button.build({
      id: 'showConversationAlreadyExistsWarningOk',
      text: 'Ok',
      callback: callback,
    });

    warningMessage.append(message);
    warningMessage.append(okButton);

    return warningMessage;
  }
  async function populateConsumerSelect(consumerSelectList) {
    const employees = await _UTIL.fetchData('getEmployeeList');

    consumerSelectList.innerHTML = '';

    if (!employees) return;

    employees?.getEmployeeListResult.forEach(employee => {
      let consumer = document.createElement('p');
      consumer.classList.add('employee');
      consumer.setAttribute('data-employer-id', employee.employerId);
      consumer.textContent = employee.employerName;

      consumerSelectList.append(consumer);
    });
  }
  function loadNewMessageView() {
    const selectedEmployees = new Set();
    let selectAllEmployees = false;

    messagesContainer.setAttribute('data-view', 'new');
    messagesContainer.innerHTML = '';

    const title = document.createElement('h4');
    title.textContent = 'Select Employees';
    title.classList.add('title');

    const message = document.createElement('p');
    message.textContent = '*Must select at least one employee before clicking save button.';
    message.classList.add('message');

    const debouncedSearch = _UTIL.debounce(e => {
      const searchTerm = e.target.value.toLowerCase();
      const consumers = consumerSelectList.querySelectorAll('p');

      consumers.forEach(consumer => {
        const employerName = consumer.textContent.toLowerCase();
        consumer.style.display =
          !employerName.includes(searchTerm) && !consumer.classList.contains('selected') ? 'none' : 'block';
      });
    }, 500);

    const searchInput = input.build({
      type: 'text',
      label: 'Search Employees',
      callbackType: 'keyup',
      className: 'employeeSearchInput',
      callback: debouncedSearch,
    });

    const consumerSelectList = document.createElement('div');
    consumerSelectList.classList.add('consumerSelectList');

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('buttonWrap');
    const selectAllBtn = button.build({
      text: 'Select All',
      style: 'secondary',
      type: 'outlined',
      callback: () => {
        const consumers = consumerSelectList.querySelectorAll('p');

        selectAllEmployees = !selectAllEmployees;

        consumers.forEach(consumer => {
          if (!selectAllEmployees) {
            consumer.classList.remove('selected');
            selectedEmployees.delete(consumer.dataset.employerId);
          } else {
            consumer.classList.add('selected');
            selectedEmployees.add(consumer.dataset.employerId);
          }
        });

        if (selectedEmployees.size > 0) {
          saveBtn.classList.remove('disabled');
          consuemrSelectedCount.textContent = `${selectedEmployees.size} users selected`;
        } else {
          saveBtn.classList.add('disabled');
          consuemrSelectedCount.textContent = '0 users selected';
        }
      },
    });
    const saveBtn = button.build({
      text: 'Save',
      style: 'secondary',
      type: 'contained',
      callback: async () => {
        let existingConversationID = null;
        let existingConversationDisplayName = null;

        const selectedEmployeesSorted = [...selectedEmployees].filter(id => id !== $.session.UserId).sort().join(',');

        Object.entries(conversationParticipantIdSets).forEach(([conversationId, { participants, displayName }]) => {
          const participantIdSetSorted = [...participants].sort().join(',');

          if (participantIdSetSorted === selectedEmployeesSorted) {
            existingConversationID = conversationId;
            existingConversationDisplayName = displayName;
          }
        });

        if (existingConversationID) {
          loadMessageDetailsView(existingConversationID, existingConversationDisplayName, false);
          return;
        }

        const response = await _UTIL.fetchData('startNewConversation', {
          currentUserId: $.session.UserId,
          recipientUserIds: [...selectedEmployees],
          messageText: DEFAULT_MESSAGE_TEXT,
        });

        const convo = response.startNewConversationResult;

        loadMessageDetailsView(convo.ConversationId, convo.DisplayName, true);
      },
    });
    saveBtn.classList.add('disabled');
    const cancelBtn = button.build({
      text: 'Cancel',
      style: 'secondary',
      type: 'contained',
      callback: () => {
        loadLandingView();
      },
    });

    const consuemrSelectedCount = document.createElement('p');
    consuemrSelectedCount.textContent = '0 users selected';
    consuemrSelectedCount.classList.add('consuemrSelectedCount');

    buttonWrap.append(selectAllBtn);
    buttonWrap.append(saveBtn);
    buttonWrap.append(cancelBtn);

    messagesContainer.append(title);
    messagesContainer.append(message);
    messagesContainer.append(searchInput);
    messagesContainer.append(consumerSelectList);
    messagesContainer.append(buttonWrap);
    messagesContainer.append(consuemrSelectedCount);

    populateConsumerSelect(consumerSelectList);

    consumerSelectList.addEventListener('click', e => {
      const employerId = e.target.dataset.employerId;

      if (e.target.classList.contains('selected')) {
        e.target.classList.remove('selected');
        selectedEmployees.delete(employerId);
      } else {
        e.target.classList.add('selected');
        selectedEmployees.add(employerId);
      }

      if (selectedEmployees.size > 0) {
        saveBtn.classList.remove('disabled');
        consuemrSelectedCount.textContent = `${selectedEmployees.size} users selected`;
      } else {
        saveBtn.classList.add('disabled');
        consuemrSelectedCount.textContent = '0 users selected';
      }
    });
  }

  //* Message View Section (where the chat happens)
  function getMessageItemHTML(message) {
    const messageItem = document.createElement('div');
    messageItem.classList.add('messageItem');
    if (message.SenderDisplayName === 'Me') {
      messageItem.classList.add('myMessage');
    }

    messageItem.innerHTML = `
      <p class="messageItemHeader">
        <span class="displayName">${message.SenderDisplayName}</span>
        <span class="sentTime">${message.FriendlySentLabel}</span>
      </p>
      <p class="messageItemBody">${message.MessageText}</p>
    `;

    return messageItem;
  }
  async function addMessageToConversation(messegeDetailsView, convoID, messageText) {
    const resp = await _UTIL.fetchData('addMessageToConversation', {
      currentUserId: $.session.UserId,
      conversationId: parseInt(convoID),
      recipientUserIds: recipientUsersById,
      messageText: messageText,
    });

    if (messegeDetailsView.dataset.empty) {
      messegeDetailsView.innerHTML = '';
      messegeDetailsView.removeAttribute('data-empty');
    }

    const message = resp.addMessageToConversationResult;
    const messageItem = getMessageItemHTML(message);
    messegeDetailsView.append(messageItem);
  }
  async function populateConversationMessages(messegeDetailsView, convoID) {
    recipientUsersById = [];

    const conversationMessages = await _UTIL.fetchData('getConversationMessages', {
      currentUserId: $.session.UserId,
      conversationId: parseInt(convoID),
    });

    const conversationMessagesUndefinedOrEmpty =
      !conversationMessages || conversationMessages.getConversationMessagesResult.length === 0;

    const conversationMessagesHaveOnlyDefaultMessage =
      conversationMessages.getConversationMessagesResult.length === 1 &&
      conversationMessages.getConversationMessagesResult[0].MessageText === DEFAULT_MESSAGE_TEXT;

    if (conversationMessagesUndefinedOrEmpty || conversationMessagesHaveOnlyDefaultMessage) {
      messegeDetailsView.setAttribute('data-empty', true);
      messegeDetailsView.innerHTML = `<p class="emptyConvoMessage">Send a message below to start the conversation.</p>`;
      return;
    }

    messegeDetailsView.innerHTML = '';

    conversationMessages?.getConversationMessagesResult.forEach(message => {
      if (!recipientUsersById.includes(message.SenderUserId)) {
        recipientUsersById.push(message.SenderUserId);
      }

      if (message.MessageText !== DEFAULT_MESSAGE_TEXT) {
        const messageItem = getMessageItemHTML(message);
        messegeDetailsView.append(messageItem);
      }
    });
  }
  function loadMessageDetailsView(convoID, displayNames, isNewConversation) {
    let newMessageText = '';

    messagesContainer.setAttribute('data-view', 'chat');
    messagesContainer.innerHTML = '';

    const backToLandingBtn = button.build({
      text: 'Back',
      style: 'secondary',
      type: 'contained',
      classNames: 'backToLandingBtn',
      callback: () => {
        loadLandingView();
      },
    });

    const messageContacts = document.createElement('p');
    messageContacts.classList.add('messageContacts');
    messageContacts.textContent = displayNames;

    const messegeDetailsView = document.createElement('div');
    messegeDetailsView.classList.add('messegeDetailsView');

    const newMessageWrap = document.createElement('div');
    newMessageWrap.classList.add('newMessageWrap');
    const newMessageInput = input.build({
      type: 'text',
      placeholder: `type message here...`,
      classNames: 'newMessageInput',
      charLimit: 255,
      forceCharLimit: true,
      // callbackType: 'input',
      callbackOnCharLimitCheck: true,
      callback: e => {
        newMessageText = e.target.value;
      },
    });
    const newMessageInputEle = newMessageInput.querySelector('input');
    newMessageInputEle.addEventListener('keydown', async e => {
      if (e.key !== 'Enter') return;
      await addMessageToConversation(messegeDetailsView, convoID, newMessageText);
      const newMessageInputEle = newMessageInput.querySelector('input');
      newMessageInputEle.value = '';
      newMessageText = '';
    });

    const newMessageSendBtn = button.build({
      text: 'Send',
      style: 'secondary',
      type: 'contained',
      classNames: 'newMessageSendBtn',
      callback: async () => {
        await addMessageToConversation(messegeDetailsView, convoID, newMessageText);
        const newMessageInputEle = newMessageInput.querySelector('input');
        newMessageInputEle.value = '';
        newMessageText = '';
      },
    });

    newMessageWrap.append(newMessageInput);
    newMessageWrap.append(newMessageSendBtn);

    messagesContainer.append(backToLandingBtn);
    messagesContainer.append(messageContacts);
    messagesContainer.append(messegeDetailsView);
    messagesContainer.append(newMessageWrap);

    populateConversationMessages(messegeDetailsView, convoID);
  }

  //* Landing Page (add new message, view conversations)
  function addParticipantsToConversationParticipantIdSets(convoId, participants, displayName) {
    const conversationParticipants = new Set();

    participants.forEach(participant => {
      if (participant.UserId !== $.session.UserId) {
        conversationParticipants.add(participant.UserId);
      }
    });

    conversationParticipantIdSets[convoId] = { participants: conversationParticipants, displayName: displayName };
  }
  function formatDisplayName(displayName) {
    if (!displayName) return '';
    const names = displayName.split(',');

    if (names.length === 1) return names[0];

    const formatedNames = names.map(fullName => {
      fullName = fullName.trim();

      const splitFullName = fullName.split(' ');
      const firstName = splitFullName[0];
      const lastNameInitial = splitFullName[1][0];

      return `${firstName} ${lastNameInitial}.`;
    });

    return formatedNames.join(', ');
  }
  async function populateConversationsList(conversationsWrap, onlyUnread) {
    const conversations = await _UTIL.fetchData('getAllConversations', {
      currentUserId: $.session.UserId,
      onlyUnread: onlyUnread,
      daysBack: $.session.defaultMessagesDaysBack,
    });

    setUnreadMessageCount(conversations);
    toggleUnreadMessageIndicator();

    conversationsWrap.innerHTML = '';

    conversationParticipantIdSets = {};

    if (!conversations) return;

    conversations?.getAllConversationsResult.forEach(convo => {
      addParticipantsToConversationParticipantIdSets(convo.ConversationId, convo.Participants, convo.DisplayName);

      const convoItem = document.createElement('div');
      convoItem.classList.add('convoItem');
      convoItem.setAttribute('data-convo-id', convo.ConversationId);
      convoItem.setAttribute('data-has-unread', convo.HasUnread);
      convoItem.setAttribute('data-display-names', convo.DisplayName);

      const convoTitle = document.createElement('p');
      convoTitle.classList.add('convoTitle');
      convoTitle.innerHTML = `
        <span class="displayName">${formatDisplayName(convo.DisplayName)}</span>
        <span class="lastMessageSent">${convo.LastMessageSentUtc}</span>
        <span class="unreadIndicator"></span>
      `;

      const covobodyWrap = document.createElement('div');
      covobodyWrap.classList.add('convoBodyWrap');
      const convobody = document.createElement('p');
      convobody.classList.add('convoBody');
      covobodyWrap.append(convobody);

      if (convo.LastMessagePreview !== DEFAULT_MESSAGE_TEXT) {
        convobody.textContent = convo.LastMessagePreview;
      } else {
        convobody.textContent = '';
      }

      convoItem.append(convoTitle);
      convoItem.append(covobodyWrap);
      conversationsWrap.append(convoItem);
    });
  }
  function loadLandingView() {
    messagesContainer.setAttribute('data-view', 'landing');
    messagesContainer.innerHTML = '';

    const newConvoBtn = button.build({
      text: 'New Message',
      style: 'primary',
      type: 'contained',
      callback: () => {
        loadNewMessageView();
      },
    });

    const unreadConvoFilter = document.createElement('div');
    const checkboxLabel = document.createElement('label');
    const checkboxInput = document.createElement('input');

    unreadConvoFilter.classList.add('unreadConvoFilter');

    checkboxLabel.textContent = 'Only show unread';
    checkboxLabel.for = 'onlyUnreadCheckbox';

    checkboxInput.type = 'checkbox';
    checkboxInput.checked = false;
    checkboxInput.id = 'onlyUnreadCheckbox';

    unreadConvoFilter.append(checkboxInput);
    unreadConvoFilter.append(checkboxLabel);

    unreadConvoFilter.addEventListener('change', e => {
      populateConversationsList(conversationsWrap, e.target.checked);
    });

    const conversationsWrap = document.createElement('div');
    conversationsWrap.classList.add('conversationsWrap');

    messagesContainer.append(newConvoBtn);
    messagesContainer.append(unreadConvoFilter);
    messagesContainer.append(conversationsWrap);

    populateConversationsList(conversationsWrap, false);

    conversationsWrap.addEventListener('click', e => {
      const convoID = e.target.dataset.convoId;
      const displayNames = e.target.dataset.displayNames;
      loadMessageDetailsView(convoID, displayNames, false);
      unReadConversations.delete(convoID);
      toggleUnreadMessageIndicator();
    });
  }

  async function checkForUnreadMessages() {
    const conversations = await _UTIL.fetchData('getAllConversations', {
      currentUserId: $.session.UserId,
      onlyUnread: true,
      daysBack: $.session.defaultMessagesDaysBack,
    });

    setUnreadMessageCount(conversations);
    toggleUnreadMessageIndicator();
  }
  async function init() {
    messagesContainer = document.getElementById('messagesContainer');
    //checkForUnreadMessages();
  }

  return {
    init,
    loadLandingView,
    checkForUnreadMessages,
  };
})();
